import {PropTypes} from "prop-types";
import Marquee from "react-fast-marquee";

const AnnouncementBar = ({children}) => {
  return (
    <Marquee autoFill={true} speed={20}>
      <div
        className="mx-6 lg:mx-10 xl:mx-24 text-white announcement-bar-content"
      >
        {children}
      </div>
    </Marquee>
  );
};

AnnouncementBar.propTypes = {
  children: PropTypes.string,
};

export default AnnouncementBar;
